import { useEffect, useRef } from 'react';

const DESKTOP_CARDS = '(min-width: 768px)';

/** Puts a child in the center of a horizontal scroller without moving the page. */
export function useCenterScrollChild(resetKey: string | undefined) {
  const containerRef = useRef<HTMLDivElement>(null);
  const childRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    const child = childRef.current;
    if (!container || !child) return;

    const center = () => {
      if (window.matchMedia(DESKTOP_CARDS).matches) return;
      const delta = child.getBoundingClientRect().left - container.getBoundingClientRect().left;
      const next = container.scrollLeft + delta - (container.clientWidth - child.offsetWidth) / 2;
      container.scrollLeft = Math.max(0, next);
    };

    center();
    const media = window.matchMedia(DESKTOP_CARDS);
    media.addEventListener('change', center);
    return () => media.removeEventListener('change', center);
  }, [resetKey]);

  return { containerRef, childRef };
}
